import { getFontFormatURLs } from '@noths/polaris-client-ribbons-base';

export const dggTheme = {
  text: {
    HEADING: {
      XL: {
        fontSize: 32,
        lineHeight: 40,
      },
      LG: {
        fontSize: 28,
        lineHeight: 36,
      },
      MD: {
        fontSize: 24,
        lineHeight: 32,
      },
      SM: {
        fontSize: 20,
        lineHeight: 28,
      },
      XS: {
        fontSize: 18,
        lineHeight: 32,
      },
    },
    BODY: {
      MD: {
        fontSize: 16,
        lineHeight: 28,
      },
      SM: {
        fontSize: 14,
        lineHeight: 24,
      },
      XS: {
        fontSize: 12,
        lineHeight: 20,
      },
    },
  },
  fonts: {
    PRIMARY_REGULAR: {
      family: 'Suisse light',
      familyWithFallbacks: "'Suisse light', Helvetica, Arial, sens-serif",
      weight: 'normal',
      formats: getFontFormatURLs('fonts/noths_suisse_light'),
    },
    PRIMARY_SEMIBOLD: {
      family: 'Suisse semibold',
      familyWithFallbacks: "'Suisse semibold', Helvetica, Arial, sens-serif",
      weight: '600',
      formats: getFontFormatURLs('fonts/noths_suisse_semibold'),
    },
  },
  spacing: {
    base: 4,
    xs: 8,
    sm: 12,
    md: 16,
    lg: 20,
    xl: 24,
    xxl: 32,
    xxxl: 48,
    xxxxl: 64,
  },
  colors: {
    wellRead: '#B83F33',
    moodyBlue: '#6D69D9',
    manz: '#F3F37F',
    sulu: '#B9EE92',
    goblin: '#3A8445',
    burntSienna: '#E95E51',
    perfume: '#E29DF0',
    parisM: '#280664',
    neutralWhite: '#FFFFFF',
    neutralBlack: '#000000',
    mediumPurple: '#7066E0',
  },
};
